import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RedoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"redo"}/>
}
